// extracted by mini-css-extract-plugin
export var chevronIcon = "_so-1";
export var edgeToggle = "_so-0";